var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { render } from "react-dom";
import { InertiaProgress } from "@inertiajs/progress";
import cronstrue from "cronstrue/i18n";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import "dayjs/locale/nb";
dayjs.extend(isoWeek);
dayjs.locale("nb");
var createInertiaApp = require("@inertiajs/inertia-react").createInertiaApp;
if (document.getElementById("app")) {
    InertiaProgress.init();
    createInertiaApp({
        resolve: function (name) { return import("./Pages/" + name); },
        setup: function (_a) {
            var el = _a.el, App = _a.App, props = _a.props;
            render(React.createElement(App, __assign({}, props)), el);
        },
    });
}
var cronElements = document.querySelectorAll(".cron-expression-descriptor");
if (cronElements.length) {
    cronElements.forEach(function (cronElement) {
        var expression = cronElement.getAttribute("data-expression");
        var descriptor = cronstrue.toString(expression, {
            use24HourTimeFormat: true,
            locale: "nb",
        });
        descriptor = descriptor
            .replace("Kl.02:00, ", "")
            .replace("Kl.02:00", "Hver dag");
        cronElement.innerHTML = descriptor;
    });
}
